<template>
	<div class="results flex flex-col items-center justify-center text-xl px-8 py-8">
		<template v-if="showCongrats">
			<div class="bg-blue-light rounded-md mx-32 p-12">
				<p>
					Félicitations !
				</p>
				<p>
					Vous venez de passer une étape importante dans votre parcours d’apprentissage.
				</p>
				<p>
					A bientôt, pour un nouvel épisode !
				</p>
			</div>
		</template>

		<table v-else-if="gameResults">
			<tr v-for="(result, gameId) in gameResults" :key="gameId">
				<td class="h-10 p-2 text-left">
					<span>
						{{(games[gameId] ? games[gameId].title : '')}}
					</span>
				</td>
				<td class="h-10 p-2 pl-12 text-right">
					<span>
						{{(result ? parseFloat(result.value * 100).toFixed(0) : 0)}}%
					</span>
				</td>
				<td class="h-10 pl-4">
					<img v-if="!result" class="inline h-full w-full thunder" src="@/assets/images/thunder-icon.svg">
					<img v-else-if="parseFloat(result.value) > 0.75" class="inline h-full w-full sun" src="@/assets/images/sun-icon.svg">
					<img v-else-if="parseFloat(result.value) > 0.5" class="inline h-full w-full cloudy" src="@/assets/images/cloudy-icon.svg">
					<img v-else-if="parseFloat(result.value) > 0.25" class="inline h-full w-full cloud" src="@/assets/images/cloud-icon.svg">
					<img v-else class="inline h-full w-full thunder" src="@/assets/images/thunder-icon.svg">
				</td>
			</tr>
		</table>

		<button
		class="faa-button-blue mt-12"
		type="button"
		@click.prevent="next">
			Continuer
		</button>
	</div>
</template>

<script>
	export default {
		name: 'Results',
		props: {
			games: {
				type: Object,
				required: true,
				default: () => {},
			},
			gameResults: {
				type: Object,
				required: true,
				default: () => {},
			},
		},
		data() {
			return {
				showCongrats: false,
			}
		},
		mounted() {
			this.showCongrats = (!this.gameResults || Object.keys(this.gameResults).length <= 0)
		},
		methods: {
			next() {
				if (!this.showCongrats) {
					this.showCongrats = true
				} else {
					this.$router.push({ name: 'Home' })
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
.results {
	img.cloudy {
		@apply pr-2;
	}

	img.cloud {
		@apply p-1;
	}
}
</style>
